module.exports = __webpack_public_path__ + "static/media/cancelMark.37b59c51.png";